import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function SeniorProductManagerSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["senior-product-manager"]} />;
}
